import { render, staticRenderFns } from "./RequestsPage.vue?vue&type=template&id=79872b95&scoped=true"
import script from "./RequestsPage.vue?vue&type=script&lang=js"
export * from "./RequestsPage.vue?vue&type=script&lang=js"
import style0 from "./RequestsPage.vue?vue&type=style&index=0&id=79872b95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79872b95",
  null
  
)

export default component.exports